import { ZM_VAT_CATEGORY_CODES } from "./zmVatCategories";

export const RECIPIENT_VAT_ID_DE_ERROR = "Recipient VAT ID must not be German.";

export const isGermanRecipientVatId = (recipientVatId?: string | null) =>
  recipientVatId?.trim().toUpperCase().startsWith("DE") ?? false;

/**
 * The recipient VAT ID field is only relevant for the ZM-relevant VAT categories
 * (60/70). Shared by the transaction view and the autocategorization rule form so
 * both agree on when the field is shown.
 */
export function showsRecipientVatIdField(
  vatCategory: string | null | undefined
): boolean {
  return ZM_VAT_CATEGORY_CODES.some((code) => code === (vatCategory ?? ""));
}

/** Value sent on upsert: `null` clears or marks N/A when the VAT category does not apply. */
export function recipientVatIdForUpsert(
  vatCategory: string | null | undefined,
  input: string | undefined | null
): string | null {
  if (!showsRecipientVatIdField(vatCategory)) {
    return null;
  }
  const trimmed = input?.trim();
  return trimmed || null;
}

/** Max length of a recipient VAT ID, mirroring the backend `STRING(20)` column. */
export const RECIPIENT_VAT_ID_MAX_LENGTH = 20;

export function isInvalidRecipientVatIdForVatCategory(
  vatCategory: string | null | undefined,
  input: string | null | undefined
): boolean {
  if (!showsRecipientVatIdField(vatCategory)) {
    return false;
  }
  // Cheap client-side checks (German id, length); the full VAT-number format
  // check stays on the backend (VIES). Shared with the transaction view.
  return (
    isGermanRecipientVatId(input) ||
    (input?.trim().length ?? 0) > RECIPIENT_VAT_ID_MAX_LENGTH
  );
}
